import React from "react";

import Box from "@mui/material/Box";

import Divider from "@mui/material/Divider";

import { Typography } from "@mui/material";
import { TextField } from "@mui/material";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { ParsedMission } from "../common/type/type";
import dayjs from "dayjs";

interface MissionDetailShowProps {
  row: ParsedMission;
}

export const MissionDetailShow: React.FC<MissionDetailShowProps> = ({
  row,
}) => {
  return (
    <div>
      <Box sx={{ width: "100%", height: "100%" }}>
        <Box
          sx={{
            width: "100%",
            margin: "0 auto",
          }}
        >
          <Box
            sx={{
              border: "1px solid #ccc",
              borderRadius: "8px",
              padding: 5,
              backgroundColor: "#f9f9f9",
              boxShadow: 1,
              width: "100%",
              margin: "0px auto",
            }}
          >
            <Box
              display="flex"
              flexDirection="column" // 縦並びにする
              alignItems="flex-start" // 左揃えにする
              margin="20px auto"
            >
              <Typography variant="subtitle1" gutterBottom>
                ミッションタイトル
              </Typography>
              <Typography variant="body1" sx={{ ml: 3, fontWeight: "bold" }}>
                {row.title}
              </Typography>
            </Box>

            <Divider
              sx={{
                width: "680px",
                borderColor: "var(--color-bold-divider)",
                borderBottomWidth: 2,
              }}
            />

            <Box
              display="flex"
              flexDirection="column" // 縦並びにする
              alignItems="flex-start" // 左揃えにする
              margin="20px auto"
            >
              <Typography variant="subtitle1" gutterBottom>
                配信期間
              </Typography>
              <Typography variant="body1" sx={{ ml: 3, fontWeight: "bold" }}>
                {dayjs(row.startedAt).format("YYYY-MM-DD HH:mm")} ～{" "}
                {row.endedAt ? dayjs(row.endedAt).format("YYYY-MM-DD HH:mm") : ""}
              </Typography>
            </Box>

            <Divider
              sx={{
                width: "680px",
                borderColor: "var(--color-bold-divider)",
                borderBottomWidth: 2,
              }}
            />

            <Box
              display="flex"
              flexDirection="column" // 縦並びにする
              alignItems="flex-start" // 左揃えにする
              margin="20px auto"
            >
              <FormControl>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  sx={{ textAlign: "left" }}
                >
                  ミッションタイプ
                </Typography>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  defaultValue={row.missionType.id}
                  sx={{ ml: 3 }}
                >
                  <FormControlLabel
                    value="019372c6-c935-7261-8955-f55c1b7d9ff2"
                    control={<Radio />}
                    label="アプリ起動"
                    disabled
                  />
                  <FormControlLabel
                    value="019372c6-c935-732d-b4cc-889b56cd7857"
                    control={<Radio />}
                    label="電気代シミュレーション"
                    disabled
                  />
                  <FormControlLabel
                    value="019372c6-c935-737e-b37c-c34141af61be"
                    control={<Radio />}
                    label="積算充電量"
                    disabled
                  />
                  <FormControlLabel
                    value="019372c6-c935-72c6-ab12-e352aba76fac"
                    control={<Radio />}
                    label="記事閲覧"
                    disabled
                  />
                </RadioGroup>
              </FormControl>
            </Box>
            {/* アプリ起動 */}
            {row.missionType.id === "019372c6-c935-7261-8955-f55c1b7d9ff2" && (
              <Box
                display="flex"
                flexDirection="column" // 縦並びにする
                alignItems="flex-start" // 左揃えにする
                margin="20px auto"
              >
                <Typography variant="subtitle1" gutterBottom>
                  ミッションの対象月
                </Typography>
                <Typography variant="body1" sx={{ ml: 4, fontWeight: "bold" }}>
                  {row.conditions.targetYearMonth}
                </Typography>
              </Box>
            )}

            {/* 積算充電量 */}
            {row.missionType.id === "019372c6-c935-737e-b37c-c34141af61be" && (
              <>
                <Box
                  display="flex"
                  flexDirection="column" // 縦並びにする
                  alignItems="flex-start" // 左揃えにする
                  margin="20px auto"
                >
                  <Typography variant="subtitle1" gutterBottom>
                    ミッションの対象月
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ ml: 4, fontWeight: "bold" }}
                  >
                    {row.conditions.targetYearMonth}
                  </Typography>
                </Box>

                <Box
                  display="flex"
                  flexDirection="column" // 縦並びにする
                  alignItems="flex-start" // 左揃えにする
                  margin="20px auto"
                >
                  <Typography variant="subtitle1" gutterBottom>
                    　積算充電量(kWh)
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ ml: 4, fontWeight: "bold" }}
                  >
                    {row.conditions.threshold}
                  </Typography>
                </Box>
              </>
            )}

            <Divider
              sx={{
                width: "680px",
                borderColor: "var(--color-bold-divider)",
                borderBottomWidth: 2,
              }}
            />

            <Box
              display="flex"
              flexDirection="column" // 縦並びにする
              alignItems="flex-start" // 左揃えにする
              margin="20px auto"
            >
              <FormControl>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  sx={{ textAlign: "left" }}
                >
                  ミッション表示タイプ
                </Typography>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  defaultValue={row.missionDisplay.missionDisplayTypeId}
                  sx={{ ml: 3 }}
                >
                  <FormControlLabel
                    value="019372c6-c935-77cd-aea1-e2749cb54862"
                    control={<Radio />}
                    disabled
                    label="ネイティブ"
                  />
                  <FormControlLabel
                    value="019372c6-c935-7000-9eef-4043e704ad85"
                    control={<Radio />}
                    disabled
                    label="WebView"
                  />
                </RadioGroup>
              </FormControl>
            </Box>

            {/* ネイティブ */}
            {row.missionDisplay.missionDisplayTypeId ===
              "019372c6-c935-77cd-aea1-e2749cb54862" && (
              <>
                {row.missionDisplay.detail.url && (
                  <Box
                    display="flex"
                    flexDirection="column" // 縦並びにする
                    alignItems="flex-start" // 左揃えにする
                    margin="20px auto"
                  >
                    <Typography variant="subtitle1" gutterBottom>
                      外部サイトのURL
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ ml: 4, fontWeight: "bold" }}
                    >
                      {row.missionDisplay.detail.url}
                    </Typography>
                  </Box>
                )}

                {/* <Box
                  display="flex"
                  flexDirection="column" // 縦並びにする
                  alignItems="flex-start" // 左揃えにする
                  margin="20px auto"
                >
                  <Typography variant="subtitle1" gutterBottom>
                    画像のURL
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ ml: 4, fontWeight: "bold" }}
                  >
                    {row.missionDisplay.detail.image}
                  </Typography>
                </Box> */}
                {row.missionDisplay.detail.description && (
                  <Box
                    display="flex"
                    flexDirection="column" // 縦並びにする
                    alignItems="flex-start" // 左揃えにする
                    margin="20px auto"
                  >
                    <Typography variant="subtitle1" gutterBottom>
                      詳細
                    </Typography>
                    <TextField
                      id="standard-multiline-static"
                      label=""
                      multiline
                      rows={10}
                      defaultValue={row.missionDisplay.detail.description.join(
                        "\n"
                      )}
                      sx={{
                        width: "60%",
                        ml: 3,
                        "& .MuiInputBase-input": {
                          fontWeight: "bold",
                          cursor: "default",
                        },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "#e0e0e0",
                          },
                          "&:hover fieldset": {
                            borderColor: "#e0e0e0",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#e0e0e0",
                          },
                        },
                      }} // 横幅を100%に
                      slotProps={{
                        input: {
                          readOnly: true,
                        },
                      }}
                    />
                  </Box>
                )}
              </>
            )}

            {/* WebView */}
            {row.missionDisplay.missionDisplayTypeId ===
              "019372c6-c935-7000-9eef-4043e704ad85" && (
              <>
                <Box
                  display="flex"
                  flexDirection="column" // 縦並びにする
                  alignItems="flex-start" // 左揃えにする
                  margin="20px auto"
                >
                  <Typography variant="subtitle1" gutterBottom>
                    URL
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ ml: 4, fontWeight: "bold" }}
                  >
                    {row.missionDisplay.detail.url}
                  </Typography>
                </Box>
              </>
            )}

            <Divider
              sx={{
                width: "680px",
                borderColor: "var(--color-bold-divider)",
                borderBottomWidth: 2,
              }}
            />

            <Box
              display="flex"
              flexDirection="column" // 縦並びにする
              alignItems="flex-start" // 左揃えにする
              margin="20px auto"
            >
              <Typography variant="subtitle1" gutterBottom>
                獲得ポイント（pt）
              </Typography>
              <Typography variant="body1" sx={{ ml: 3, fontWeight: "bold" }}>
                {row.point}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </div>
  );
};
